/** Página pública exibida quando a conta do estabelecimento está suspensa. */
export default function BloqueadoPage() {
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center">
      <div className="text-center max-w-sm px-6 animate-scale-in">
        <div className="w-16 h-16 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto mb-5 shadow-[0_0_32px_rgba(239,68,68,0.15)]">
          <svg className="w-7 h-7 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>
        <p className="text-white font-semibold text-lg">Conta suspensa</p>
        <p className="text-slate-500 text-sm mt-2">
          O acesso a este estabelecimento foi temporariamente bloqueado.
          Entre em contato com o suporte.
        </p>
      </div>
    </div>
  );
}
